import {useEffect, useMemo, useState} from 'react'

import {useFindColumnByDatabaseId} from '../columns/use-find-column-by-database-id'
import type {ChartState} from './use-charts'

/**
 * A hook to validate the chart configuration based on the current _local_ chart state
 * @param chart
 * @returns
 */
export function useValidateChartConfiguration(chartConfiguration: ChartState['localVersion']['configuration']) {
  const {findColumnByDatabaseId} = useFindColumnByDatabaseId()
  const [isValid, setIsValid] = useState(true)

  useEffect(() => {
    const invalidFieldIds = new Set<number>()

    if (typeof chartConfiguration.xAxis.dataSource.column === 'number') {
      const columnId = chartConfiguration.xAxis.dataSource.column
      const column = findColumnByDatabaseId(columnId)
      if (!column) {
        invalidFieldIds.add(columnId)
      }
    }

    if (chartConfiguration.xAxis.groupBy) {
      const columnId = chartConfiguration.xAxis.groupBy.column
      const column = findColumnByDatabaseId(columnId)
      if (!column) {
        invalidFieldIds.add(columnId)
      }
    }

    if (chartConfiguration.yAxis.aggregate.columns) {
      for (const columnId of chartConfiguration.yAxis.aggregate.columns) {
        const column = findColumnByDatabaseId(columnId)
        if (!column) {
          invalidFieldIds.add(columnId)
        }
      }
    }
    setIsValid(invalidFieldIds.size === 0)
  }, [
    chartConfiguration.filter,
    chartConfiguration.xAxis.dataSource.column,
    chartConfiguration.xAxis.groupBy,
    chartConfiguration.yAxis.aggregate.columns,
    findColumnByDatabaseId,
  ])

  return useMemo(
    () => ({
      isValid,
    }),
    [isValid],
  )
}
